<!--
  This is a temporary component to display the benchmark version items in a test page.
-->
<template>
  <div v-if="items && items.length > 0">
    <div v-for="item in items" :key="item.benchmarkTitle">
      benchmarkTitle: <sc-text :field="item.fields.benchmarkTitle" /><br />
      technologyVersion: <sc-text :field="item.fields.technologyVersion" /><br />
      benchmarkVersion: <sc-text :field="item.fields.benchmarkVersion" /><br />
      published: <sc-text :field="item.fields.published" /><br />
      pro: <sc-text :field="item.fields.pro" /><br />
      proV4: <sc-text :field="item.fields.proV4" /><br />
      community: <sc-text :field="item.fields.community" /><br />
      discussionTitle: <sc-text :field="item.fields.discussionTitle" /><br />
      discussionLastUpdated:<sc-text :field="item.fields.discussionLastUpdated" /><br />
      discussionUrl: <sc-text :field="item.fields.discussionUrl" /><br />
      <!-- Documents -->
      <div v-if="item.documents && item.documents.length > 0">
        <h4>Versions:</h4>
        <resource-benchmark-document v-bind:items="item.documents" />
      </div>
      <!-- Images -->
      <div v-if="item.images && item.images.length > 0">
        <h4>Versions:</h4>
        <resource-benchmark-image v-bind:items="item.images" />
      </div>
      <!-- Remediation Kit -->
      <div v-if="item.remediationKits && item.remediationKits.length > 0">
        <h4>Versions:</h4>
        <resource-benchmark-remediationKit v-bind:items="item.remediationKits" />
      </div>
    </div>
  </div>
</template>

<script>
import ResourceBenchmarkDocument from './CIS_Resource-Benchmark-Document.vue';
import ResourceBenchmarkImage from './CIS_Resource-Benchmark-Image.vue';
import ResourceBenchmarkRemediationKit from './CIS_Resource-Benchmark-RemediationKit.vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Benchmark-Version',
  props: {
    items: {
      type: Array
    }
  },
  components: {
    ScText: Text,
    ResourceBenchmarkDocument,
    ResourceBenchmarkImage,
    ResourceBenchmarkRemediationKit
  }
};
</script>
